export default "__VITE_ASSET__C_Tdi_V2__"